import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppBrand from '../components/AppBrand';

function TermsPage({ theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card">
          <div className="legal-page-badge">Legal</div>
          <h1 className="legal-page-title">Terms of Service</h1>

          <section className="legal-section">
            <h2>1. Overview</h2>
            <p>
              These Terms of Service govern your access to and use of StockVested,
              including our analyzer, journal, performance tracking, website, and
              related services. By creating an account, accessing the platform, or
              purchasing a subscription, you agree to these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Eligibility</h2>
            <p>
              You must be legally able to enter into a binding agreement in your
              jurisdiction to use this service. By using the platform, you represent
              that you meet that requirement.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Nature of the Service</h2>
            <p>
              StockVested is a research, journaling, educational, and performance
              review platform. The service is intended to help users organize trade
              ideas, review setups, document decision-making, and track process.
            </p>
            <p>
              The platform is not a broker-dealer, investment adviser, law firm,
              accounting firm, or fiduciary. Use of the platform does not create an
              advisory, fiduciary, or professional-client relationship.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. User Responsibility</h2>
            <p>
              You are solely responsible for your trading, investing, financial, and
              risk-management decisions. You are responsible for evaluating whether
              any information, analysis, or output from the platform is appropriate
              for your circumstances.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account
              credentials and for all activity that occurs under your account. You
              agree to provide accurate information and to notify us if you believe
              your account has been compromised.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>use the platform for unlawful, fraudulent, or abusive purposes</li>
              <li>attempt to reverse engineer, scrape, or misuse the service</li>
              <li>interfere with platform stability, security, or availability</li>
              <li>misrepresent platform outputs as professional advice or guarantees</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Subscription Access</h2>
            <p>
              Certain features may require a paid subscription. Access levels,
              features, pricing, trial availability, and usage limits may change over
              time. Continued use after those changes constitutes acceptance of the
              updated terms, subject to applicable law.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Intellectual Property</h2>
            <p>
              The platform, branding, software, design, and site content are owned by
              StockVested or its licensors and are protected by applicable
              intellectual property laws. You may use the service only as permitted by
              these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. No Warranty</h2>
            <p>
              The platform is provided on an “as is” and “as available” basis. We do
              not guarantee uninterrupted availability, accuracy, completeness,
              profitability, suitability, or fitness for a particular purpose.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, StockVested and its owners,
              operators, affiliates, employees, and contractors will not be liable for
              any indirect, incidental, special, consequential, exemplary, or lost
              profit damages arising out of or related to your use of the platform.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Termination</h2>
            <p>
              We may suspend or terminate access to the service if you violate these
              Terms, misuse the platform, or create legal, operational, or security
              risk.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Updated Terms become
              effective when posted unless otherwise stated.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;